import { Moment } from 'moment';

export class MachineState {
  machineId: string;
  state: string;
  updatedTime: Moment;
  stateBag: string;
}
